import { render } from "./ModalDelete.vue?vue&type=template&id=7a520cda&scoped=true&lang=pug"
import script from "./ModalDelete.vue?vue&type=script&lang=js"
export * from "./ModalDelete.vue?vue&type=script&lang=js"

import "./ModalDelete.vue?vue&type=style&index=0&id=7a520cda&lang=scss&scoped=true"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a520cda"]])

export default __exports__